var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"feather feather-circle",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20.5","height":"20.5","viewBox":"0 0 20.5 20.5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"10.25","cy":"10.25","r":"9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }